import type { AdType } from "@gik/ads/components/Ad";
import { isBrowser } from "@gik/core/utils/environment";
import classnames from "classnames";
import type React from "react";

const blockName = "ad-container";
export const adBlockElName = `${blockName}__ad`;

export default function AdContainer({
	children,
	className = "",
	adType,
}: React.PropsWithChildren<{
	className?: string;
	adType: AdType;
}>) {
	const blockClassNames: string = classnames([
		blockName,
		`${blockName}--${adType}`,
		className,
	]);

	if (isBrowser()) {
		return (
			<div className={blockClassNames}>
				<p>ADVERTISEMENT</p>
				{children}
			</div>
		);
	} else {
		return null;
	}
}
